<template>
	<div class="finish-mapping-step-tab">
		<div class="mb-2">Mapping result:</div>
		<TableView class="flex-1" :headers="headers" :rows="finalResult" />
	</div>
</template>

<script>
import TableView from '@/components/common/TableView/TableView';

export default {
	name: 'FinishMappingStep',
	components: {
		TableView,
	},
	props: {
		state: { type: Object },
		finalResult: { type: Array },
		isHeadersMappingMode: { type: Boolean },
	},
	computed: {
		headers() {
			let headers;
			if (this.isHeadersMappingMode) {
				headers = Object.keys(this.finalResult[0]);
			} else {
				headers = Object.keys(this.state.columnsMapping);
			}
			return headers.map((h) => ({ field: h }));
		},
	},
};
</script>
<style scoped lang="scss"></style>
